import { feedBack } from '../actionTypes';

const startAddingNote = payload => ({
  type: feedBack.START_ADDING_NOTE,
  payload
});
const successAddingNote = payload => ({
  type: feedBack.SUCCESS_ADDING_NOTE,
  payload
});

const errorAddingNote = payload => ({
  type: feedBack.FAILURE_ADDING_NOTE,
  payload
});

export const addFeedBackNote = (id, note, created_by, callback) => dispatch => {
  dispatch(startAddingNote());
  dispatch({
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic',
      method: 'POST',
      queryParams: {
        clear_cache: true
      },
      body: {
        data_tag: 'DATATAG_DELIGHTIQ_ADD_NOTES',
        request_data: {
          id,
          note,
          created_by
        }
      }
    },

    onSuccess: note_response => {
      dispatch(successAddingNote({ note_response })
    );
      if (callback) callback(true);
    },

    onError: ({ error }) => {
      dispatch(errorAddingNote({ error }));
    }
  });
};